import React from 'react'

export default function GovernmentRevenues() {
  return (
    <div>GovernmentRevenues</div>
  )
}
